// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pit96","rootMobile":"styles_rootMobile__3f6kS"};